<template>
  <div>
    <div class="chat-card" @click="onClick">
      <div class="chat-status" v-if="cardData.status === 'COMPLETED'">已完成</div>
      <div class="chat-text">
        <div class="answer-title">{{ cardData.title }}</div>
        <div class="answer-tips">{{ cardData.tips }}</div>
      </div>
      <div class="chat-img">
        <img class="img" :src="cardData.imgUrl" alt="">
      </div>
    </div>
  </div>
</template>

<script>

export default {
  name: 'ChatAnswerSheet',
  components: {
  },
  props: {
    cardData: {
      type: Object,
      required: true
    }
  },
  methods: {
    onClick() {
      this.$emit("click", this.cardData)
    }
  },
};
</script>

<style scoped lang="scss">
.chat-card {
  position: relative;
  width: 305px;
  border-radius: 12px;
  padding: 10px 20px 10px;
  background: #EDF4FC;
  box-sizing: border-box;
  display: flex;
  align-items: center;
  justify-content: space-between;
  .chat-text {
    .answer-title {
      font-size: 17.6px;
      font-weight: 400;
      color: rgba(59, 59, 59, 1);
      text-align: left;
      vertical-align: top;
      margin-bottom: 10px;
    }
    .answer-tips {
      font-size: 9.9px;
      font-weight: 400;
      color: rgba(0, 0, 0, 0.2);
      text-align: left;
      vertical-align: top;
    }
  }
  .chat-img {
    width: 62px;
    height: 62px;
    .img {
      width: 100%;
      height: 100%;
    }
  }
}
.chat-status {
  position: absolute;
  top: 0;
  left: 20px;
  width: 41.8px;
  height: 13.2px;
  opacity: 1;
  border-radius: 0 0 5.5px 5.5px;
  background: rgba(0, 122, 255, 1);
  font-size: 8.8px;
  font-weight: 500;
  letter-spacing: 0;
  line-height: 13.2px;
  color: rgba(255, 255, 255, 1);
  text-align: center;
  vertical-align: top;
}

</style>